import { createSessionConsumer } from './actionCableConsumer';

interface UserCustomizationChannelParams {
  connectedHandler?: () => void;
  disconnectedHandler?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  receivedHandler?: (data: any) => void;
}

const userCustomizationChannel = ({
  connectedHandler,
  disconnectedHandler,
  receivedHandler
}: UserCustomizationChannelParams) => {
  const consumer = createSessionConsumer('user customization');
  if (!consumer) return;

  return consumer.subscriptions.create(
    {
      channel: 'UserCustomizationChannel'
    },
    {
      connected: connectedHandler,
      disconnected: disconnectedHandler,
      received: receivedHandler
    }
  );
};

export default userCustomizationChannel;
